<script setup lang="ts">
import { useIntersectionOnce } from '@/utils/composables/useIntersectionOnce';

const { isVisible, setRef } = useIntersectionOnce({ threshold: 0 });
</script>

<template>
  <div :ref="setRef">
    <slot v-if="isVisible" />
  </div>
</template>
